<template>
    <div class="list-show-slider">
      <v-card
        class="mx-auto"
      >
        <v-toolbar
          color="#E72480"
          dark
        >

          <v-toolbar-title style="font-weight: bold;font-size: 2rem">اسلایدر</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="addDialog" >
            <v-icon>mdi-plus-thick  </v-icon>
          </v-btn>
        </v-toolbar>
      <v-list three-line>
        <template v-for="(item) in originalSlider.results" class="items-slider" >

          <v-divider
          ></v-divider>
          <v-list-item
          >


            <v-list-item-content>
              <div  style="display: flex;padding: 10px 0;">
                <v-list-item-title v-if="titleSlider" class="item-title" >{{item.title}}</v-list-item-title>
                <div class="icons"> <v-btn plain text elevation="2" @click="deleteData(item.id)" icon>
                  <v-icon color="red">mdi-delete  </v-icon>
                </v-btn> <v-btn class="ml-2" plain text elevation="2"  @click="edit(item.title,item.text,item.buttonLink,item.id)" icon>
                  <v-icon color="blue">mdi-pencil  </v-icon>
                </v-btn></div>
              </div>
              <v-list-item-action-text  v-if="textSlider" class="item-text"><span style="font-weight: bold">متن مورد نظر اسلایدر:</span>{{item.text}}</v-list-item-action-text>
              <v-list-item-action-text v-if="linkSlider" class="item-text"><span style="font-weight: bold">لینک مورد نظر:</span>{{item.buttonLink}}</v-list-item-action-text>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      </v-card>
      <v-dialog
        v-model="dialog"
        max-width="800"
      >
        <v-card style="background-color: #d2d2d2;padding: 40px">
          <form-slider class="form-slider"  :editData="editData"  :imageSlider="imageSlider" :textSlider="textSlider" :titleSlider="titleSlider" :dateSlider="dateSlider" :linkSlider="linkSlider"  ></form-slider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black darken-1"
              text
              @click="dialog = false"
            >
              بیخیال
            </v-btn>
            <v-btn
              color="black darken-1"
              text
              @click="sendData"
              :disabled="!this.$store.state.ruleMainPage"
              v-show="!isEdit"
              :loading="loadingSend"
            >
              انجام شد
            </v-btn>
            <v-btn
              color="black darken-1"
              text
              @click="recordData"
              :disabled="!this.$store.state.ruleMainPage  "
              v-show="isEdit"
              :loading="loadingSend"
            >
              ویرایش کنید.
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
  import formSlider from '../component/formSlider'
  import { setSliders , putSliders , deleteSliders } from '../../../api/mainpage/topSection'
  import {mapGetters,mapActions} from 'vuex'

  export default {
    name: "listShowSlider",
    components:{
      formSlider,
    },
      props:{
        imageSlider: Boolean,
        textSlider:Boolean,
        titleSlider:Boolean,
        dateSlider:Boolean,
        linkSlider:Boolean,
      },
      data :() => ({
        loadingSend:false,
        isEdit: false,
        dialog: false,
        editId:0,
        editData :{title:'',text:'',link:''},

       }),
    methods:{
          async sendData(){
            this.loadingSend = true

            try{
              await setSliders({
                title : this.$store.state.firstSliderMainPage.slider.title,
                text : this.$store.state.firstSliderMainPage.slider.text,
                buttonLink: this.$store.state.firstSliderMainPage.slider.buttonLink
              })
              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            }catch(e){
             this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
           }
            this.$store.state.firstSliderMainPage.slider.title = '';
            this.$store.state.firstSliderMainPage.slider.text= '';
            this.$store.state.firstSliderMainPage.slider.buttonLink = ''
            this.getSliderReq()
            this.dialog = false
            this.loadingSend = false
          },
          edit(title, text,link,id){
            this.dialog = true
            this.isEdit = true
            this.editData.title = title
            this.editData.text = text
            this.editData.link = link
            this.editId = id
          },
          addDialog(){
            this.isEdit = false
            this.dialog = true
            this.editData.title = ''
            this.editData.text = ''
            this.editData.link = ''
          },
          async recordData(){
            this.loadingSend = true
            try {
              await putSliders({
                title: this.$store.state.firstSliderMainPage.slider.title,
                text: this.$store.state.firstSliderMainPage.slider.text,
                buttonLink: this.$store.state.firstSliderMainPage.slider.buttonLink
              }, this.editId)
              this.snackBarAction({
                color: "#4CAF50",
                textSnackBar: 'عملیات فرستادن با موفقیت اعمال شد',
                showSnackbar: true
              })
            }catch(e){
             this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
           }
            this.$store.state.firstSliderMainPage.slider.title = '';
            this.$store.state.firstSliderMainPage.slider.text= '';
            this.$store.state.firstSliderMainPage.slider.buttonLink = ''
            this.getSliderReq()
            this.loadingSend = false
            this.dialog = false

          },
          async deleteData(id){
            let yes = confirm("مطمئنی میخوای پاک کنی!");
             if(yes){
               await deleteSliders(id).then(()=>{
                 this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات پاک شدن با موفقیت اعمال شد', showSnackbar:true})
               }).catch(()=>{
                 this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})

               })

             }
            this.getSliderReq()

          },
        ...mapActions({
           getSliderReq :'firstSliderMainPage/fetchSlider',
          snackBarAction:'snackBar/snackBarAction'


        }),
    },
    computed: {
      ...mapGetters({
        originalSlider: 'firstSliderMainPage/get_slider',
      })
    },
    mounted () {
          this.getSliderReq()
      // this.getSliderReq().then(
      //       this.originalSlider =  this.$store.state.firstSliderMainPage.lastSlider
      //     )
     }
  }
</script>

<style scoped>
.items-slider{
  font-size: 1.5rem !important;
}
  .item-title{
    font-size: 1.7rem !important;
    font-weight: bold;
  }
  .item-text{
    font-size: 1.3rem;
    margin-bottom: 10px;
  }
  .icons{
    display: flex;
    flex-direction: row-reverse;
    width: max-content;
  }
  .form-slider{
    padding: 40px 0;
  }
</style>
